import Axios from 'axios';

/**
 * 
 * @param {'oid2uuid' | 'uuid2oid'} mode 
 * @param {string} body
 * @returns 
 */
export async function idsConvert(mode, body) {
    return Axios({
        method: 'post',
        url: `/api/v2/dev-utils/convert-ids?mode=${mode}`,
        headers: {
            'Content-Type': 'text/plain',
        },
        data: body,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

/**
 * 
 * @param {string} _id 
 * @returns 
 */
export async function idsEntities(_id) {
    return Axios({
        method: 'post',
        url: '/api/v2/dev-utils/get-entity',
        withCredentials: true,
        data: { _id },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/devUtils.js